import { all, call, put, takeLatest } from 'redux-saga/effects';
import { basketOperations, basketTypes } from '../../store/basket';

import { createError } from '../../store/errors';
import { deleteBasket } from '../../api/basket';

const { RESET_BASKET } = basketTypes;

export const performResetBasket = function* performResetBasket({ payload }) {
  const { resetBasketSuccess } = basketOperations;

  try {
    const { bookingRef, errors } = yield call(deleteBasket, payload.bookingRef);

    if (errors) {
      // Handle web service errors.
      yield all(errors.map(error => put(createError(error))));
    } else {
      yield put(resetBasketSuccess(bookingRef));
    }
  } catch (error) {
    // don't do anything
  }
};

export default takeLatest(RESET_BASKET, performResetBasket);
